import { Button } from '@/components/ui/button'
import { Icon } from '@iconify/react'
import { NavLink, useLocation } from 'react-router-dom'
import { CreativeAnalyticsSubNavbar } from '@/layouts/dashboard/nav/subnavs/CreativeAnalyticsSubNavbar.jsx'
import { ResearchSubNavbar } from '@/layouts/dashboard/nav/subnavs/ResearchSubNavbar.jsx'
import { LibrarySubNavbar } from '@/layouts/dashboard/nav/subnavs/LibraryNavbar.jsx'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover.jsx'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar.jsx'
import { useAuthContext } from '@/context-state/AuthContext.jsx'
import { toggleInvitationDialog } from '@/hooks/useInviteMember.jsx'
import { useEffect } from 'react'
import { CustomTooltip } from '@/components/custom-tooltip/CustomTooltip.jsx'
import { AnalyticsService } from '@/services/analytics.js'
import { TypographyLarge, TypographySmall, TypographySmallMuted } from '@/components/ui/typography.jsx'
// import { show as showIntercom } from '@intercom/messenger-js-sdk/index.js'
import { SettingsSubNavbar } from '@/layouts/dashboard/nav/subnavs/SettingsSubNavbar.jsx'
import { UserRoles } from '@/consts/index.js'
import { RoleGuard } from '@/guards/RoleGuard.jsx'
import { SpaceSelector } from '@/components/space-selector/SpaceSelector'
import { useCurrentSpace } from '@/hooks/useCurrentSpace'
import { ClipsLibrarySubNavbar } from '@/layouts/dashboard/nav/subnavs/ClipsLibrarySubNavbar'

export const NavBar = ({ isExpanded, setIsExpanded }) => {

    const { pathname } = useLocation()
    const { user, logout } = useAuthContext()
    const { space } = useCurrentSpace()
    const spaceFirstLetter = space?.name?.slice(0, 1).toUpperCase()

    const userInitial = user.name?.slice(0, 1).toUpperCase()
    let subNavBar = null

    if (pathname.includes('creative')) {
        subNavBar = <CreativeAnalyticsSubNavbar />
    }
    if (pathname.includes('research')) {
        subNavBar = <ResearchSubNavbar />
    }

    if (pathname.includes('library')) {
        subNavBar = <LibrarySubNavbar />
    }

    if (pathname.includes('clips-library')) {
        subNavBar = <ClipsLibrarySubNavbar />
    }

    if (pathname.includes('settings')) {
        subNavBar = <SettingsSubNavbar />
    }

    useEffect(() => {
        if (user.testUser) {
            setIsExpanded(false)
            return
        }
        if (!subNavBar) {
            setIsExpanded(false)
            return
        }
        setIsExpanded(true)

    }, [pathname])


    return (
        <div className="flex h-screen fixed z-50">
            {/* Primary Sidebar */}
            <div className="w-12 bg-background border-r flex flex-col items-center py-4 gap-2">


                <Popover>
                    <PopoverTrigger asChild>

                        <Button size="sm" className="p-2.5 h-7">
                            {spaceFirstLetter}
                        </Button>
                    </PopoverTrigger>
                    <PopoverContent className="w-64 p-4 ml-10 -mt-10">
                        <div className="flex flex-col items-center space-y-4">
                            <TypographySmall className="font-light flex items-center gap-2">
                                <Icon icon="material-symbols-light:planet-outline-rounded" className="h-4 w-4 flex-shrink-0" />
                                Change Space
                            </TypographySmall>
                            <SpaceSelector />
                            {/* <RoleGuard minimumRoleRequired={UserRoles.ADMIN} level="account" hideContent>
                                <Button
                                    variant="ghost"
                                    className="w-full flex gap-2"
                                    onClick={() => {
                                        // setTempText(text)
                                        // setIsEditing(true)
                                    }}
                                >
                                    Create New
                                </Button>
                            </RoleGuard> */}
                        </div>
                    </PopoverContent>
                </Popover>


                <CustomTooltip content="Creative Analytics" position="right">
                    <NavLink
                        to="creative"
                        className={({ isActive }) => `transition-all group flex gap-x-3 p-2 text-sm leading-6 ${isActive ? 'text-primary' : 'text-muted-foreground'}`}
                    >
                        <Icon icon="uim:analytics" className={`h-5 w-5 shrink-0`} aria-hidden="true" />
                    </NavLink>
                </CustomTooltip>

                <CustomTooltip content="Research" position="right">
                    <NavLink
                        to="research"
                        className={({ isActive }) => `transition-all group flex gap-x-3 p-2 text-sm leading-6 ${isActive ? 'text-primary' : 'text-muted-foreground'} ${user.testUser ? 'hidden' : ''}`}
                    >
                        <Icon icon="mingcute:telescope-line" className={`h-5 w-5 shrink-0`} aria-hidden="true" />
                    </NavLink>
                </CustomTooltip>

                {/* <CustomTooltip content="Library" position="right">
                    <NavLink
                        to="library"
                        className={({ isActive }) => `transition-all group flex gap-x-3 p-2 text-sm leading-6 ${isActive ? 'text-primary' : 'text-muted-foreground'} ${user.testUser ? 'hidden' : ''}`}
                    >
                        <Icon icon="solar:folder-with-files-linear" className={`h-5 w-5 shrink-0`} aria-hidden="true" />
                    </NavLink>
                </CustomTooltip> */}

                <div className="mt-auto flex flex-col items-center gap-2">

                    {/* 
                    <CustomTooltip content="Integrations" position="right">
                        <NavLink
                            to="integrations"
                            className={({ isActive }) => `transition-all group flex gap-x-3 p-2 text-sm leading-6 ${isActive ? 'text-primary' : 'text-muted-foreground'} ${user.testUser ? 'hidden' : ''}`}
                        >
                            <Icon icon="hugeicons:connect" className="w-5 h-5 text-muted-foreground" />
                        </NavLink>
                    </CustomTooltip> */}

                    <CustomTooltip content="Settings" position="right">
                        <NavLink
                            to="settings"
                            className={({ isActive }) => `transition-all group flex gap-x-3 p-2 text-sm leading-6 ${isActive ? 'text-primary' : 'text-muted-foreground'} ${user.testUser ? 'hidden' : ''}`}
                        >
                            <Icon icon="uil:setting" className="w-5 h-5" />
                        </NavLink>
                    </CustomTooltip>

                    <RoleGuard minimumRoleRequired={UserRoles.ADMIN} hideContent>
                        <CustomTooltip content="Invite Member" position="right">
                            <Button
                                size="sm"
                                variant="ghost"
                                className={`rounded-full ${user.testUser ? 'hidden' : ''}`}
                                onClick={() => toggleInvitationDialog(true)}
                            >
                                <Icon icon="mdi:invite" className="w-5 h-5 text-muted-foreground" />
                            </Button>
                        </CustomTooltip>
                    </RoleGuard>

                    <CustomTooltip content="Contact Support" position="right">
                        <Button
                            size="sm"
                            variant="ghost"
                            className="rounded-full"
                        // onClick={showIntercom}
                        >
                            <a href="mailto:info@upspring.ai">
                                <Icon icon="material-symbols:help-outline" className="w-5 h-5 text-muted-foreground" />
                            </a>
                        </Button>
                    </CustomTooltip>

                    <Popover>
                        <PopoverTrigger asChild>
                            <Avatar className="border-primary-200 border h-8 w-8 text-sm cursor-pointer">
                                <AvatarImage src={user.profileImage} alt={user.name} />
                                <AvatarFallback>{userInitial}</AvatarFallback>
                            </Avatar>
                        </PopoverTrigger>
                        <PopoverContent className="w-64 p-4">
                            <div className="flex flex-col items-center space-y-4">
                                <Avatar className="w-14 h-14">
                                    <AvatarImage src={user.profileImage} alt={user.name} />
                                    <AvatarFallback className="text-2xl">{userInitial}</AvatarFallback>
                                </Avatar>
                                <div className="text-center">
                                    <TypographyLarge>Hello, {user.name}</TypographyLarge>
                                    <TypographySmallMuted className="font-light">Welcome back!</TypographySmallMuted>
                                    {/* <AccountSettingsDialog /> */}
                                </div>

                                <Button
                                    variant="outline"
                                    className="w-full flex gap-2"
                                    onClick={() => {
                                        AnalyticsService.track('user-logged-out', { userName: user.name, userId: user._id })
                                        logout()
                                    }}
                                >
                                    <Icon icon="solar:logout-2-broken" />
                                    Logout
                                </Button>
                            </div>
                        </PopoverContent>
                    </Popover>
                </div>

            </div>

            {/* Toggle button for collapsed state */}
            <Button
                variant={isExpanded ? 'ghost' : "outline"}
                size="icon"
                className={`absolute transition bottom-10 z-50 rounded-full w-7 h-7  ${isExpanded ? 'right-[6px]' : 'right-[-12px] rotate-180'} ${subNavBar ? '' : 'hidden'}`}
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <Icon icon="lsicon:double-arrow-left-filled" className="h-4 w-4 " />
            </Button>

            {/* Secondary Sidebar */}
            <div className={`bg-background/60 backdrop-blur-md border-r transition-all duration-300 overflow-hidden ${isExpanded ? 'w-60' : 'w-0 opacity-0'}`}>
                {subNavBar}
            </div>

        </div>
    )
}

